import { useEffect, useMemo } from 'react';

import { useAccountEntitlements } from '@adsk/alloy-provider';

import { useIdleTimer } from '../providers/IdleTimerProvider';
import getMinEnabledIdleDuration from '../utils/getMinEnabledIdleDuration';

export const IdleTimerAllAccountsListener = () => {
  const { update } = useIdleTimer();
  const { data: accountEntitlements } = useAccountEntitlements();

  const isLoading = accountEntitlements === null;
  const minEnabledDuration = useMemo(() => {
    return getMinEnabledIdleDuration(accountEntitlements?.accounts || []);
  }, [accountEntitlements]);

  useEffect(() => {
    if (!isLoading) {
      update({ timeoutMs: minEnabledDuration });
    }
  }, [isLoading, minEnabledDuration, update]);

  return null;
};
